import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBooleanGroupIntersect"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM16 14.5V8H9.5V3.5H20.5V14.5H16ZM8 9.5H3.5V20.5H14.5V16H8V9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect;
